import { render, staticRenderFns } from "./ReviewReply.vue?vue&type=template&id=35ae7688&scoped=true"
import script from "./ReviewReply.vue?vue&type=script&lang=js"
export * from "./ReviewReply.vue?vue&type=script&lang=js"
import style0 from "./ReviewReply.vue?vue&type=style&index=0&id=35ae7688&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae7688",
  null
  
)

export default component.exports